import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { UserRol } from "./api-interfaces/userrol.interface";
import { DeleteUserInterface } from "./api-interfaces/api-interface-delete-user";
import { environmentPingId ,pingIdToken} from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class APIUserManagamentService {
    ApiURL: string = "";
    constructor(private http: HttpClient) {
        this.ApiURL = environmentPingId.PingIdvehicleDataUrl + 'users';
    }
public TokenApiUsers = ""
    public get(id:string): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.TokenApiUsers}`);
        const requestOptions = {
            headers: headers,
          };
        if(id !== null && id !== undefined) {
          return this.http.get(this.ApiURL + encodeURIComponent(id),requestOptions);
        }
        else {
            return this.http.get(this.ApiURL,requestOptions);
        }
    }

    public getDropdownUser(roleOwnerId:number,countryId?: string, secondId?: string, thirdId?: string, fourthId?: string): Observable<any> {
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${this.TokenApiUsers}`)
        .set('x-apikey', pingIdToken.clientId);
      const requestOptions = {
        headers: headers,
      };
      const body : any = {
        proleOwnerId : String(roleOwnerId ? roleOwnerId : ""),
        pcountryId : String(countryId? countryId : ""),
        proleId : String(secondId? secondId : ""),
        pretailId : String(thirdId? thirdId : ""),
        pworkshopId : String(fourthId? fourthId : "")
      }
      return this.http.post(this.ApiURL + "/dropdown/info", body, requestOptions);
    }

    public createUser(firstName:string,lastName: string, email: string, countryId: string,language:string, roleId:string, isActive:string, userIncadea: string,userMixto: string, companyID:string, retailId?: any, workshopId?: any, ServiceAdvisor?: any,): Observable<any> {
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${this.TokenApiUsers}`)
        .set('x-apikey', pingIdToken.clientId);
      const requestOptions = {
        headers: headers,
      };

      if(ServiceAdvisor === "0" || isNaN (ServiceAdvisor)) ServiceAdvisor = null
      if(workshopId === "0") workshopId = null
      if(retailId === "0") retailId = null
      const body : any = {
        firstName: firstName ?? "",
        lastName: lastName ?? "",
        email: email ?? "",
        countryId: countryId ?? "",
        retailId: retailId ?? "",
        workshopId: workshopId ?? "",
        ServiceAdvisor: ServiceAdvisor ?? "",
        language: language ?? "",
        roleId: roleId ?? "",
        isActive: isActive ?? "",
        isIncadea: userIncadea ?? "",
        UserMix: userMixto ?? "",
        companyID: companyID ?? ""
      }
      return this.http.post(this.ApiURL + "/json/create", body, requestOptions);
    }

    public updateUser(firstName:string,lastName: string, email: string, countryId: string,language:string, roleId:string, isActive:string,IsIncadea?: any, CompanyId?: any, retailId?: any, workshopId?: any, ServiceAdvisor?: any, ): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.TokenApiUsers}`);
        const requestOptions = {
            headers: headers,
          };

        if(ServiceAdvisor === "0" || isNaN (ServiceAdvisor)){ServiceAdvisor = null;}
        if(workshopId === "0") workshopId = null
        if(retailId === "0") retailId = null
        let diccionary =
        {
            "firstName": String(firstName),
            "lastName": String (lastName),
            "email": String (email),
            "countryId": String (countryId),
            "retailId": retailId,
            "workshopId": workshopId,
            "ServiceAdvisor": ServiceAdvisor,
            "language": String (language),
            "roleId": String (roleId),
            "isActive": String (isActive),
            "isIncadea": String (IsIncadea),
            "companyId": String (CompanyId),
          }
         const url =
        `${this.ApiURL}/UpdateUserJson`
         return this.http.post(url,diccionary,requestOptions);
    }

    public getUserDataById(userId: number): Observable<any> {
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${this.TokenApiUsers}`)
        .set('x-apikey', pingIdToken.clientId);
      const requestOptions = {
        headers: headers,
      };
      const body: any = {
        UserId: Number(userId) ??  0
      };
      return this.http.post<any>(this.ApiURL + "/info", body, requestOptions);
    }

    public put(data):Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.TokenApiUsers}`);
        const requestOptions = {
            headers: headers,
          };
    return this.http.put<any>(this.ApiURL,data,requestOptions) //include id
    }

    public delete(id: number):  Observable<DeleteUserInterface>{
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${this.TokenApiUsers}`)
        .set('x-apikey', pingIdToken.clientId);
      const requestOptions = {
          headers: headers,
      };
      const body: any = {
        Userid : Number(id) ?? 0
      }
      return this.http.post<any>(this.ApiURL + "/role/delete", body, requestOptions);
    }

    public getUsterByRetail(id:any, token:string){
      this.TokenApiUsers = token
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${this.TokenApiUsers}`)
        .set('x-apikey', pingIdToken.clientId);
      const requestOptions = {
        headers: headers,
      };
      const body: any = {
        RetailId: Number(id) ??  0
      };
      return this.http.post<any>(this.ApiURL +"/info", body, requestOptions);
    }

    public patchChangeState(id:any,status:Boolean){
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${this.TokenApiUsers}`)
        .set('x-apikey', pingIdToken.clientId);
      const requestOptions = {
        headers: headers,
      };
      const body= {
        UserId: id,
        Status: status
      }
      return this.http.post(this.ApiURL+"/update/partial",body,requestOptions);
    }

  public LoginBooking(data):Observable<any> {

return this.http.post<any>(this.ApiURL +"/login",data)
}

}
